import {GPSPosData} from "../helpers/gps-pos-data-helper";
import {Card} from "./card";
import {BaseEntity} from "./base-entity";

export abstract class CardInfoModelBase {
  public cardId: number;
  public productId: number;
  public customerId: number;
  public customerFirstname: string;
  public customerLastname: string;
  public cardToken: string;
  public productName: string;
}

export class AnnualFeeInfoModel extends CardInfoModelBase {
  public dueDate: Date;
  public amount: number;
}

export class CardExpiryInfoModel extends CardInfoModelBase {
  public expiryDate: Date;
}

export class CardActivityInfoModel extends CardInfoModelBase {
  public activityDate: Date;
  public amount: number;
  public activityType: CardActivityType;
  public txnStatCode: string;
  public currencyCode: number;
  public description: string;
  public notes: string;
  public procCode: string;
  public posData: string;

  public gpsPosData: GPSPosData|null = null;
}

export enum CardActivityType {
  Load = 0,
  Presentment = 1,
  CashWithdrawal = 2,
  Authorization = 3,
  Reversal = 4,
  LoadFromPrimary = 5,
  BalanceAdjustment = 6,
  Other = 99,
}

export enum CardType {
  Unknown = 0,
  Virtual = 1,
  Physical = 2,
  InitiallyVirtual = 3,
  Mvc = 4,
  Pseudo = 900,
}

export class CardActivity extends BaseEntity {
  activityDate: Date;
  activityType: CardActivityType;
  cardId?: number | null;
  card: Card;
  txnStatCode: string;
  txnId: string;
  cashbackProcessed: boolean;
  description: string;
  mccCode?: number | null;
  merchantCountry: string;
  merchantName: string;
  billAmount: number;
  billCurrency: number;
  settleAmount: number;
  settleCurrency: number;
  gpsPosData: string; // See https://developer.globalprocessing.com/ehi/Content/Appendices/GPS_POS_Data.htm
  feeFixed: number;
  feeRate: number;
  fxFeeFixed: number;
  fxFeeRate: number;
  procCode: string;
  blkAmt: number;
  avlBal: number;
  merchantId: string;
  metaTxnId?: number | null;
  txnAmt: number;
  txnCcy: number;
}
